import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { SearchComponent } from './pages/search/search.component';
import { NoClientComponent } from './pages/no-client/no-client.component';
import { CitationPaymentsComponent } from './pages/citation-payments/citation-payments.component';
import { ClearingComponent } from './pages/clearing/clearing.component';
import { InitGuard } from './services/auth-guard.service';

const routes: Routes = [
	{ path: '', component: SearchComponent, canActivate: [InitGuard] },
	{ path: 'home', component: HomeComponent, canActivate: [InitGuard] },
	{ path: 'search', component: SearchComponent },
	{ path: 'pay-citations', component: CitationPaymentsComponent },
	{ path: 'pay-items', component: CitationPaymentsComponent },
	{ path: 'clearing', component: ClearingComponent },
	{ path: 'no-client', component: NoClientComponent }
];


@NgModule({
	imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
	exports: [RouterModule]
})
export class AppRoutingModule { }

export const routingComponents = [
	HomeComponent, 
	SearchComponent,
	CitationPaymentsComponent, 
	ClearingComponent,
	NoClientComponent
]